"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMarketingType = void 0;
var IMarketingType;
(function (IMarketingType) {
    IMarketingType["Library"] = "library";
    IMarketingType["Favorites"] = "favorites";
    IMarketingType["LiveBike"] = "live-bike";
    IMarketingType["LiveTreadmill"] = "live-treadmill";
    IMarketingType["LiveStrength"] = "live-strength";
    IMarketingType["UpgradeExpired"] = "upgrade-expired";
    IMarketingType["UpgradeAnonymous"] = "upgrade-anonymous";
    IMarketingType["Custom"] = "custom";
})(IMarketingType || (exports.IMarketingType = IMarketingType = {}));
//# sourceMappingURL=marketing-type.js.map